export const BASE = {
  name: 'dashboard-quantz',
  path: '/sites/:siteId/dashboard',
};
